module.exports = __webpack_public_path__ + "img/2019_0.dc326df4.webp";